'use client'

import React, { useEffect, useMemo, useState } from 'react'

import { X } from '@phosphor-icons/react'

import { Header, StyledModal, StyledModalProps } from './styles'

type Props = Omit<StyledModalProps, 'isOpen' | 'overlayClassName'> & {
  children?: React.ReactNode
  closeButton?: boolean
  isOpen?: boolean
  shouldCloseOnOverlayClick?: boolean
  onClose?: () => void
}

function Modal({
  children,
  closeButton = true,
  isOpen = false,
  shouldCloseOnOverlayClick = true,
  onClose,
  ...rest
}: Props) {
  const [mounted, setMounted] = useState(false)

  const rootElement = useMemo(() => {
    if (!mounted) return undefined

    return window.document.getElementById('root')
  }, [mounted])

  useEffect(() => {
    setMounted(true)
  }, [])

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  if (!mounted || !rootElement) return null

  return (
    <StyledModal
      {...rest}
      appElement={rootElement}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
    >
      {closeButton && (
        <Header>
          <X
            size={20}
            style={{ cursor: 'pointer' }}
            weight="bold"
            onClick={onClose}
          />
        </Header>
      )}

      {children}
    </StyledModal>
  )
}

export default Modal
